import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 3;
  padding: 16px;
`;

export const Header = styled.div`
  margin-bottom: 24px;
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  padding: 8px;

  img {
    width: 32px;
    height: 32px;
  }
`;

export const TextContainer = styled.div`
  text-align: center;
  margin-bottom: 48px;

  p {
    color: ${({ theme }) => theme.colors.subtle};
  }
`;

export const ScanContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 400px;
  margin: 0 auto;
`;
